import { transport } from 'config/transport';

export function callApiRegisterSubjects(congDoanId, classId, dangKyBody) {
    return transport.post(`/mamnon/${congDoanId}/thuhocsinh/${classId}/dangky/register`, dangKyBody);
}
